import request from './request';

export async function getSections(): Promise<{
  sections: {
    id: string;
    name: string;
    nameEn: string;
    nameDe: string;
    active: boolean;
    createdAt: number;
    updatedAt: number;
  }[];
}> {
  return request('GET', '/api/gallery/sections');
}

export async function getSectionImages(
  sectionId: string,
  page: number = 1,
  perPage: number = 20
): Promise<{
  page: number;
  totalPages: number;
  totalCount: number;
  data: {
    id: string;
    image?: string;
    sectionId?: string;
    createdAt?: number;
  }[];
}> {
  return request(
    'GET',
    `/api/gallery/sections/${sectionId}/images?page=${page}&perPage=${perPage}`
  );
}

export async function deleteSectionImage(sectionId: string, imageId: string) {
  return request(
    'DELETE',
    `/api/gallery/sections/${sectionId}/images/${imageId}`
  );
}

export async function deleteSection(sectionId: string) {
  return request('DELETE', `/api/gallery/sections/${sectionId}`);
}

export async function createSection(
  name: string,
  nameEn: string,
  nameDe: string,
  active: boolean
) {
  return request('POST', '/api/gallery/sections', {
    name,
    nameEn,
    nameDe,
    active,
  });
}

export async function updateSection(
  id: string,
  name: string,
  nameEn: string,
  nameDe: string,
  active: boolean
) {
  return request('POST', `/api/gallery/sections/${id}`, {
    name,
    nameEn,
    nameDe,
    active,
  });
}
